import { render, staticRenderFns } from "./normalItem.vue?vue&type=template&id=591c086e&scoped=true"
import script from "./normalItem.vue?vue&type=script&lang=js"
export * from "./normalItem.vue?vue&type=script&lang=js"
import style0 from "./normalItem.vue?vue&type=style&index=0&id=591c086e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591c086e",
  null
  
)

export default component.exports